import { QuoteTab } from '@/features/leads/components/Detail/Tabs/QuoteTab';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/leads/lead/$id/quote')({
  component: QuoteTab,
});
